import { render, staticRenderFns } from "./TituloPrincipal.vue?vue&type=template&id=a0731198&scoped=true"
import script from "./TituloPrincipal.vue?vue&type=script&lang=ts"
export * from "./TituloPrincipal.vue?vue&type=script&lang=ts"
import style0 from "./TituloPrincipal.vue?vue&type=style&index=0&id=a0731198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0731198",
  null
  
)

export default component.exports